import { DefaultWidths } from "./types";

export const defaultWidths: DefaultWidths = {
  "iphone-x": "375px", // iPhone X width
  "2k": "2048px", // 2K width
  desktop: "1920px", // Desktop width
  "1080p": "1920px", // 1080p width
  "720p": "1280px", // 720p width
  "4k": "3840px", // 4K width
  "100%": "100%", // Default for custom width or unspecified width
};
